export default __webpack_public_path__ + "static/media/magento.2ce36c7f.svg";